module.exports = __webpack_public_path__ + "media/images/blue-eye-icon-41f213214845632961c942154840ba10.svg";